import { AlertTriangle, ArrowRight } from "lucide-react";

/**
 * Sticky urgency banner — pinned above the nav.
 * Advertises the Swiss 2028 fiscal reform: renovation deductions disappear.
 * The whole strip is clickable → smooth-scrolls to the WhatsApp/quote section.
 */
export const UrgencyBanner = () => {
  return (
    <a
      href="#fiscal-2028"
      data-testid="urgency-banner"
      aria-label="Réforme fiscale 2028 : en savoir plus"
      className="fixed top-0 left-0 right-0 z-[60] block bg-charcoal-deep text-white border-b border-white/10 hover:bg-charcoal transition-colors duration-300"
    >
      <div className="max-w-7xl mx-auto px-3 sm:px-6 h-11 sm:h-11 flex items-center justify-center gap-2 sm:gap-3 text-center">
        <AlertTriangle
          className="w-3.5 h-3.5 sm:w-4 sm:h-4 text-bronze-light flex-shrink-0"
          strokeWidth={2}
        />
        <p className="text-[11px] sm:text-[13px] leading-tight tracking-wide font-light truncate">
          {/* Full text on md+ */}
          <span className="hidden md:inline">
            <strong className="font-medium">Propriétaires genevois :</strong>{" "}
            déduisez vos travaux de rénovation de vos impôts — La loi change en 2028.
          </span>
          {/* Compact text on mobile */}
          <span className="md:hidden">
            <strong className="font-medium">Rénovez avant 2028</strong>, déduisez vos impôts.
          </span>{" "}
          <span
            data-testid="urgency-banner-cta"
            className="inline-flex items-center gap-1 text-bronze-light underline underline-offset-4 decoration-bronze-light/60 hover:text-white hover:decoration-white transition-colors font-medium whitespace-nowrap"
          >
            Profitez-en maintenant
            <ArrowRight className="w-3 h-3 sm:w-3.5 sm:h-3.5" strokeWidth={2} />
          </span>
        </p>
      </div>
    </a>
  );
};
